/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Timer_LabelInputs */

const en_timer_label = /** @type {(inputs: Timer_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer · ${i?.time}`)
};

const de_timer_label = /** @type {(inputs: Timer_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer · ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Timer · {time}" |
*
* @param {Timer_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const timer_label = /** @type {((inputs: Timer_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_timer_label(inputs)
	return en_timer_label(inputs)
});